import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Cvetochki: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Cvetochki/kP8020153.jpg"},
        {src: "/image/Cvetochki/kP5150013.jpg"},
        {src: "/image/Cvetochki/kP5090013.jpg"},
        {src: "/image/Cvetochki/kP5150015.jpg"},
        {src: "/image/Cvetochki/kP5150008.jpg"},
        {src: "/image/Cvetochki/kP5150007.jpg"},
        {src: "/image/Cvetochki/kP3120085.jpg"},
        {src: "/image/Cvetochki/kP3120087.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Цветы из бисера",
        "Цветы из бисера на леске и проволоке. Маленькие и большие цветы из мелкого, среднего и крупного бисера и стекляруса. Веточка из бисера и стекляруса."
    )

    return <>
        <h2>Цветы из бисера</h2>
        <div className="row catalog">
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP8020153.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Веточка из бисера и стекляруса"
                    id="image-0"
                    onClick={viewImage}
                />
                <p className="name"><Link to="/vetochka">Веточка со стеклярусом</Link></p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP5150013.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Маленькие цветочки на проволоке"
                    id="image-1"
                    onClick={viewImage}
                />
                <p className="name">Цветочки на проволоке</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP5090013.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Цветок"
                    id="image-2"
                    onClick={viewImage}
                />
                <p className="name">Цветок</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP5150015.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Цветок"
                    id="image-3"
                    onClick={viewImage}
                />
                <p className="name">Цветок</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP5150008.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Цветок"
                    id="image-4"
                    onClick={viewImage}
                />
                <p className="name">Цветок</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP5150007.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Разные цветы"
                    id="image-5"
                    onClick={viewImage}
                />
                <p className="name">Такие разные цветы!</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP3120085.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Цветок"
                    id="image-6"
                    onClick={viewImage}
                />
                <p className="name">Цветок</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img
                    src="/image/Cvetochki/mP3120087.jpg" className="img-rounded img-responsive col-centered"
                    width="227" height="170" alt="Цветок"
                    id="image-7"
                    onClick={viewImage}
                />
                <p className="name">Цветок</p>
            </div>
        </div>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Cvetochki;

